import React from 'react';
import { motion } from 'framer-motion';
import TechyAnimation from './TechyAnimation';

const ServiceHero = ({ title, subtitle }) => {
  return (
    <div className="bg-gray-50/50 relative overflow-hidden">
      {/* Background dot pattern */}
      <div className="absolute inset-0 z-0 bg-[radial-gradient(#e5e7eb_1px,transparent_1px)] [background-size:1.5rem_1.5rem]"></div>
      
      <div className="container mx-auto px-4 py-24 relative z-10">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
          >
            <h1 className="text-5xl font-bold font-heading mb-4 text-[#0D2B45]">{title}</h1>
            <p className="text-lg text-gray-600 max-w-2xl">{subtitle}</p>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="hidden md:flex justify-center items-center h-full"
          >
            <TechyAnimation />
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default ServiceHero; 